import React, { useEffect, useRef, useState } from "react"
import _ from "lodash"
import { HeaderBack } from '@/components/common/header';
import { _getAllVehicleBrandList, _getDealerList, _handleOnClickDealerCall } from '../../libraries/common';
import { PhoneCallListModal } from '../../components/modal';
import { TagButton } from "../common/button";
import { FaPhoneAlt, FaDirections } from "react-icons/fa";
import { DealerSection } from ".";
import { mobileViewWidth, pageLink } from "../../config/site";
import { GoogleMap, useJsApiLoader, MarkerF, InfoWindowF } from "@react-google-maps/api";
import { Footer } from "../common/footer";
import { AllMeta } from '@/components/common/meta';
import Head from "next/head";
import { MyBody } from "../body/body";
import { customRouterLink } from "../../libraries/appCommon";


const PhoneTitle = (props) => {
    const { label = "" } = props
    return (
        <div className="phoneTitle_row">
            <div className="phoneTitle_background" />
            <div className="phoneTitle_box">
                <p className="fontSize_10 fontWeight_bold fontColor_darkBlue">
                    {label}
                </p>
            </div>
        </div>
    )
}

export const DealerDetail = (props) => {
    const { t, device, session, fetchedData } = props;
    const [loading, setLoading] = useState(true);
    const containerRef = useRef(null)

    // dealer
    const [dealerList, setDealerList] = useState([])
    const [phoneCallOpen, setPhoneCallOpen] = useState(false)
    const [phoneNumberList, setPhoneNumberList] = useState([])

    // google map
    const { isLoaded, loadError } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: process.env.NEXT_PUBLIC_GOOGLE_MAP_API
    })
    const [map, setMap] = useState(null)

    // const onLoad = useCallback(function callback(map) {
    //     // This is just an example of getting and using the map instance!!! don't just blindly copy!
    //     const bounds = new window.google.maps.LatLngBounds({lat: parseFloat(fetchedData.latitude),lng: parseFloat(fetchedData.longitude)});
    //     map.fitBounds(bounds);
    
    //     setMap(map)
    // }, [])

    // const onUnmount = useCallback(function callback(map) {
    //     setMap(null)
    // }, [])

    useEffect(()=>{
        let isMounted = true; // Flag to track component mount status

        const fetchData = async() =>{
            try{
                setLoading(true)
                await _getDealerList({vehicleBrandId: fetchedData.vehicle_brand_id, limit: 6, offset: 0, not_in_id: fetchedData.dealer_id}, setDealerList);
            }catch(error){
                console.log(error)
            }finally{
                if (isMounted) {
                    // Only update state if the component is still mounted
                    setLoading(false);
                }
            }
        }
        
        if(fetchedData){
            fetchData();
            if(window.innerWidth <= mobileViewWidth){
                window.scrollTo({
                    top: 1,
                    behavior: 'instant'
                });
            } else {
                if (containerRef.current) {
                    containerRef.current.scrollTo({
                    top: 0,
                    behavior: 'instant'
                    });
                }
            }
        }

        return () => {
            isMounted = false; // Mark the component as unmounted
        };
    },[fetchedData])  

    return (
        <>
            <AllMeta
                title={t('dealerDetailPage_meta_title', { brand: fetchedData?.brand_name })}
                description={t('dealerDetailPage_meta_description', { brand: fetchedData?.brand_name })}
                keyword={t('dealerDetailPage_meta_keyword', { brand: fetchedData?.brand_name })}
                image={!_.isEmpty(fetchedData?.brand_image) ? `${process.env.NEXT_PUBLIC_FS_URL}${fetchedData?.brand_image}` : undefined}
                imageWidth={512}
                imageheight={512}
            />
            <Head><title>{t('dealerDetailPage_title', { brand: fetchedData?.brand_name })}</title></Head>
            <MyBody
                t={t}
                containerRef={containerRef}
                headerComponent={
                    <HeaderBack t={t} searchVisible={false} />
                }
                modalComponent={
                    <PhoneCallListModal
                        phoneCallOpen={phoneCallOpen}
                        setPhoneCallOpen={setPhoneCallOpen} 
                        phoneNumberList={phoneNumberList}
                        t={t}
                    />
                }
            >
                <div style={{ minHeight: '30rem'}}>
                {
                    isLoaded && 
                    <GoogleMap
                        mapContainerStyle={{
                            width: '100%',
                            height: '30rem'
                        }}
                        center={{
                            lat: parseFloat(fetchedData.latitude),
                            lng: parseFloat(fetchedData.longitude)
                        }}
                        zoom={13}
                        // onLoad={onLoad}
                        // onUnmount={onUnmount}
                    >
                        <MarkerF 
                            position={{
                                lat: parseFloat(fetchedData.latitude), 
                                lng: parseFloat(fetchedData.longitude)
                            }}
                        />
                        <InfoWindowF
                            position={{
                                lat: parseFloat(fetchedData.latitude), 
                                lng: parseFloat(fetchedData.longitude)
                            }}
                            zIndex={1}
                            options={{
                                pixelOffset: {
                                    width: 0,
                                    height: -40,
                                }
                            }}
                        >
                            <div>
                                <p className="fontSize_12 fontWeight_semiBold">
                                    {fetchedData?.name}
                                </p>
                            </div>
                        </InfoWindowF>
                    </GoogleMap>
                }
                </div>
                <div>
                    <div className="dealerDetail_box">
                        <div className="containerPadding">
                            <p className="fontSize_16 fontWeight_semiBold">
                                {
                                    !_.isEmpty(fetchedData?.rating) &&
                                    <span className="dealerTitle_row_tag primaryButtonBackground fontSize_10 fontWeight_medium fontColor_white">
                                        {fetchedData?.rating}
                                    </span>
                                }
                                {fetchedData?.name}
                            </p>
                            <div className="dealerTitle_tagList">
                                <div className="dealerTitle_tagList_active">
                                    {!_.isEmpty(fetchedData?.brand_name) && <TagButton label={fetchedData.brand_name} linkUrl={pageLink.dealer.dealerMidUrl + fetchedData.brand_custom_url} extraClass={"tagButton_sm"} />}
                                    {!_.isEmpty(fetchedData?.state) && <TagButton label={fetchedData.state} linkUrl={pageLink.dealer.dealerMidUrl + "state-" + fetchedData.state.toLowerCase().split(' ').join('-')} extraClass={"tagButton_sm"} />}
                                </div>
                            </div>
                        </div>
                        <div className="dealerTitle_info_row containerPadding">
                            <div className="dealerTitle_info_content_row" style={{alignItems: 'flex-start'}}>
                                <div className="dealerTitle_info_content_row_inner_left">
                                    <div className="dealer_item_row_2_icon dealerTitle_info_row_icon">
                                        <img 
                                            className="w-100"
                                            src="/assets/images/address_circle_icon_blue.svg"
                                        />
                                    </div>
                                    <p className="fontSize_12 fontColor_grey flex_1">
                                        {fetchedData?.address}
                                    </p>
                                </div>
                                <a
                                    onClick={()=>{customRouterLink({href: `http://maps.google.com/maps?q=loc:${fetchedData.latitude},${fetchedData.longitude}`, action: 'navigationTab', target: "_blank"})}}
                                    className="dealerTitle_info_content_row_inner_right"
                                >
                                    {/* <div className="dealerTitle_info_content_row_inner_right_background">
                                        <BiSolidDirections 
                                            className="dealerTitle_info_content_row_inner_right_icon"
                                            color={"#fff"}
                                        />
                                    </div> */}
                                    <FaDirections 
                                        size={30}
                                        color={'#99D8EA'}
                                    />
                                </a>
                            </div>
                        </div>
                        {
                            !(JSON.parse(fetchedData?.show_room_no)?.length === 0 || (JSON.parse(fetchedData?.show_room_no)?.length === 1 && JSON.parse(fetchedData?.show_room_no)[0] === '')) &&
                            <div className="dealerTitle_info_row">
                                <PhoneTitle label={"Show Room"} />
                                <div className="dealerTitle_info_content_container">
                                    {
                                        _.reduce(JSON.parse(fetchedData?.show_room_no), (result, value, key)=>{
                                            result.push(
                                                <a key={key} onClick={()=>{customRouterLink({href: `tel: ${value}`, action: 'navigationTab'})}} className="dealerTitle_info_content_row containerPadding">
                                                    <div className="dealerTitle_info_content_row_icon dealerTitle_info_row_icon">
                                                        <FaPhoneAlt size={10} color={"#99d8ea"} />
                                                    </div>
                                                    <div>
                                                        <p className="fontSize_12 fontColor_grey">
                                                            {value}
                                                        </p>
                                                    </div>
                                                </a>
                                            )
                                            return result
                                        },[])
                                    }
                                </div>
                            </div>
                        }
                        {
                            !(JSON.parse(fetchedData?.service_no)?.length === 0 || (JSON.parse(fetchedData?.service_no)?.length === 1 && JSON.parse(fetchedData?.service_no)[0] === '')) &&
                            <div className="dealerTitle_info_row">
                                <PhoneTitle label={"Service"} />
                                <div className="dealerTitle_info_content_container">
                                    {
                                        _.reduce(JSON.parse(fetchedData?.service_no), (result, value, key)=>{
                                            result.push(
                                                <a key={key} onClick={()=>{customRouterLink({href: `tel: ${value}`, action: 'navigationTab'})}} className="dealerTitle_info_content_row containerPadding">
                                                    <div className="dealerTitle_info_content_row_icon dealerTitle_info_row_icon">
                                                        <FaPhoneAlt size={10} color={"#99d8ea"} />
                                                    </div>
                                                    <div>
                                                        <p className="fontSize_12 fontColor_grey">
                                                            {value}
                                                        </p>
                                                    </div>
                                                </a>
                                            )
                                            return result
                                        },[])
                                    }
                                </div>
                            </div>
                        }
                        {
                            !(JSON.parse(fetchedData?.body_paint_no)?.length === 0 || (JSON.parse(fetchedData?.body_paint_no)?.length === 1 && JSON.parse(fetchedData?.body_paint_no)[0] === '')) &&
                            <div className="dealerTitle_info_row">
                                <PhoneTitle label={"Body Paint"} />
                                <div className="dealerTitle_info_content_container">
                                    {
                                        _.reduce(JSON.parse(fetchedData?.body_paint_no), (result, value, key)=>{
                                            result.push(
                                                <a key={key} onClick={()=>{customRouterLink({href: `tel: ${value}`, action: 'navigationTab'})}} className="dealerTitle_info_content_row containerPadding">
                                                    <div className="dealerTitle_info_content_row_icon dealerTitle_info_row_icon">
                                                        <FaPhoneAlt size={10} color={"#99d8ea"} />
                                                    </div>
                                                    <div>
                                                        <p className="fontSize_12 fontColor_grey">
                                                            {value}
                                                        </p>
                                                    </div>
                                                </a>
                                            )
                                            return result
                                        },[])
                                    }
                                </div>
                            </div>
                        }
                        {/* <div className="dealerTitle_bottom_row">
                            <div onClick={()=>{_handleOnClickDealerCall(fetchedData, setPhoneNumberList, setPhoneCallOpen)}} className="secondaryButton">
                                <p className="fontSize_14 fontWeight_semiBold fontColor_white">
                                    Call Now
                                </p>
                            </div>
                            {
                                (!_.isEmpty(fetchedData.latitude) && !_.isEmpty(fetchedData.longitude)) &&
                                <a
                                    href={`http://maps.google.com/maps?q=loc:${fetchedData.latitude},${fetchedData.longitude}`}
                                    className="secondaryButton"
                                >
                                    <p className="fontSize_14 fontWeight_semiBold fontColor_white">
                                        Direction
                                    </p>
                                </a>
                            }
                        </div> */}
                    </div>
                </div>
                <div className="dealerDetail_dealerSection_margin">
                    <DealerSection
                        t={t} 
                        data={dealerList} 
                        brandName={fetchedData?.brand_name} 
                        brandCustomUrl={fetchedData?.brand_custom_url}
                        loading={loading} 
                        setPhoneNumberList={setPhoneNumberList}
                        setPhoneCallOpen={setPhoneCallOpen}
                    />
                </div>
            </MyBody>
        </>
    )
    
    // return (
    //     <>
    //         <AllMeta
    //             title={t('dealerDetailPage_meta_title', { brand: fetchedData?.brand_name })}
    //             description={t('dealerDetailPage_meta_description', { brand: fetchedData?.brand_name })}
    //             keyword={t('dealerDetailPage_meta_keyword', { brand: fetchedData?.brand_name })}
    //             image={!_.isEmpty(fetchedData?.brand_image) ? `${process.env.NEXT_PUBLIC_FS_URL}${fetchedData?.brand_image}` : undefined}
    //             imageWidth={512}
    //             imageheight={512}
    //         />
    //         <Head><title>{t('dealerDetailPage_title', { brand: fetchedData?.brand_name })}</title></Head>
    //         <div className='bodyContainer'>
    //             <div ref={containerRef} className='contentContainer' style={{paddingBottom: '2rem'}}>
    //                 <HeaderBack t={t} searchVisible={false} />
    //                 {
    //                     isLoaded && 
    //                     <GoogleMap
    //                         mapContainerStyle={{
    //                             width: '100%',
    //                             height: '30rem'
    //                         }}
    //                         center={{
    //                             lat: parseFloat(fetchedData.latitude),
    //                             lng: parseFloat(fetchedData.longitude)
    //                         }}
    //                         zoom={13}
    //                         // onLoad={onLoad}
    //                         // onUnmount={onUnmount}
    //                     >
    //                         <MarkerF 
    //                             position={{
    //                                 lat: parseFloat(fetchedData.latitude), 
    //                                 lng: parseFloat(fetchedData.longitude)
    //                             }}
    //                         />
    //                         <InfoWindowF
    //                             position={{
    //                                 lat: parseFloat(fetchedData.latitude), 
    //                                 lng: parseFloat(fetchedData.longitude)
    //                             }}
    //                             zIndex={1}
    //                             options={{
    //                                 pixelOffset: {
    //                                     width: 0,
    //                                     height: -40,
    //                                 }
    //                             }}
    //                         >
    //                             <div>
    //                                 <p className="fontSize_12 fontWeight_semiBold">
    //                                     {fetchedData?.name}
    //                                 </p>
    //                             </div>
    //                         </InfoWindowF>
    //                     </GoogleMap>
    //                 }
    //                 <div>
    //                     <div className="dealerDetail_box">
    //                         <div className="containerPadding">
    //                             <p className="fontSize_16 fontWeight_semiBold">
    //                                 {
    //                                     !_.isEmpty(fetchedData?.rating) &&
    //                                     <span className="dealerTitle_row_tag primaryButtonBackground fontSize_10 fontWeight_medium fontColor_white">
    //                                         {fetchedData?.rating}
    //                                     </span>
    //                                 }
    //                                 {fetchedData?.name}
    //                             </p>
    //                             <div className="dealerTitle_tagList">
    //                                 <div className="dealerTitle_tagList_active">
    //                                     {!_.isEmpty(fetchedData?.brand_name) && <TagButton label={fetchedData.brand_name} linkUrl={pageLink.dealer.dealerMidUrl + fetchedData.brand_custom_url} extraClass={"tagButton_sm"} />}
    //                                     {!_.isEmpty(fetchedData?.state) && <TagButton label={fetchedData.state} linkUrl={pageLink.dealer.dealerMidUrl + "state-" + fetchedData.state.toLowerCase().split(' ').join('-')} extraClass={"tagButton_sm"} />}
    //                                 </div>
    //                             </div>
    //                         </div>
    //                         <div className="dealerTitle_info_row containerPadding">
    //                             <div className="dealerTitle_info_content_row" style={{alignItems: 'flex-start'}}>
    //                                 <div className="dealerTitle_info_content_row_inner_left">
    //                                     <div className="dealer_item_row_2_icon dealerTitle_info_row_icon">
    //                                         <img 
    //                                             className="w-100"
    //                                             src="/assets/images/address_circle_icon_blue.svg"
    //                                         />
    //                                     </div>
    //                                     <p className="fontSize_12 fontColor_grey flex_1">
    //                                         {fetchedData?.address}
    //                                     </p>
    //                                 </div>
    //                                 <a
    //                                     href={`http://maps.google.com/maps?q=loc:${fetchedData.latitude},${fetchedData.longitude}`} 
    //                                     className="dealerTitle_info_content_row_inner_right"
    //                                 >
    //                                     {/* <div className="dealerTitle_info_content_row_inner_right_background">
    //                                         <BiSolidDirections 
    //                                             className="dealerTitle_info_content_row_inner_right_icon"
    //                                             color={"#fff"}
    //                                         />
    //                                     </div> */}
    //                                     <FaDirections 
    //                                         size={30}
    //                                         color={'#99D8EA'}
    //                                     />
    //                                 </a>
    //                             </div>
    //                         </div>
    //                         {
    //                             !(JSON.parse(fetchedData?.show_room_no)?.length === 0 || (JSON.parse(fetchedData?.show_room_no)?.length === 1 && JSON.parse(fetchedData?.show_room_no)[0] === '')) &&
    //                             <div className="dealerTitle_info_row">
    //                                 <PhoneTitle label={"Show Room"} />
    //                                 <div className="dealerTitle_info_content_container">
    //                                     {
    //                                         _.reduce(JSON.parse(fetchedData?.show_room_no), (result, value, key)=>{
    //                                             result.push(
    //                                                 <a key={key} href={`tel: ${value}`} className="dealerTitle_info_content_row containerPadding">
    //                                                     <div className="dealerTitle_info_content_row_icon dealerTitle_info_row_icon">
    //                                                         <FaPhoneAlt size={10} color={"#99d8ea"} />
    //                                                     </div>
    //                                                     <div>
    //                                                         <p className="fontSize_12 fontColor_grey">
    //                                                             {value}
    //                                                         </p>
    //                                                     </div>
    //                                                 </a>
    //                                             )
    //                                             return result
    //                                         },[])
    //                                     }
    //                                 </div>
    //                             </div>
    //                         }
    //                         {
    //                             !(JSON.parse(fetchedData?.service_no)?.length === 0 || (JSON.parse(fetchedData?.service_no)?.length === 1 && JSON.parse(fetchedData?.service_no)[0] === '')) &&
    //                             <div className="dealerTitle_info_row">
    //                                 <PhoneTitle label={"Service"} />
    //                                 <div className="dealerTitle_info_content_container">
    //                                     {
    //                                         _.reduce(JSON.parse(fetchedData?.service_no), (result, value, key)=>{
    //                                             result.push(
    //                                                 <a key={key} href={`tel: ${value}`} className="dealerTitle_info_content_row containerPadding">
    //                                                     <div className="dealerTitle_info_content_row_icon dealerTitle_info_row_icon">
    //                                                         <FaPhoneAlt size={10} color={"#99d8ea"} />
    //                                                     </div>
    //                                                     <div>
    //                                                         <p className="fontSize_12 fontColor_grey">
    //                                                             {value}
    //                                                         </p>
    //                                                     </div>
    //                                                 </a>
    //                                             )
    //                                             return result
    //                                         },[])
    //                                     }
    //                                 </div>
    //                             </div>
    //                         }
    //                         {
    //                             !(JSON.parse(fetchedData?.body_paint_no)?.length === 0 || (JSON.parse(fetchedData?.body_paint_no)?.length === 1 && JSON.parse(fetchedData?.body_paint_no)[0] === '')) &&
    //                             <div className="dealerTitle_info_row">
    //                                 <PhoneTitle label={"Body Paint"} />
    //                                 <div className="dealerTitle_info_content_container">
    //                                     {
    //                                         _.reduce(JSON.parse(fetchedData?.body_paint_no), (result, value, key)=>{
    //                                             result.push(
    //                                                 <a key={key} href={`tel: ${value}`} className="dealerTitle_info_content_row containerPadding">
    //                                                     <div className="dealerTitle_info_content_row_icon dealerTitle_info_row_icon">
    //                                                         <FaPhoneAlt size={10} color={"#99d8ea"} />
    //                                                     </div>
    //                                                     <div>
    //                                                         <p className="fontSize_12 fontColor_grey">
    //                                                             {value}
    //                                                         </p>
    //                                                     </div>
    //                                                 </a>
    //                                             )
    //                                             return result
    //                                         },[])
    //                                     }
    //                                 </div>
    //                             </div>
    //                         }
    //                         {/* <div className="dealerTitle_bottom_row">
    //                             <div onClick={()=>{_handleOnClickDealerCall(fetchedData, setPhoneNumberList, setPhoneCallOpen)}} className="secondaryButton">
    //                                 <p className="fontSize_14 fontWeight_semiBold fontColor_white">
    //                                     Call Now
    //                                 </p>
    //                             </div>
    //                             {
    //                                 (!_.isEmpty(fetchedData.latitude) && !_.isEmpty(fetchedData.longitude)) &&
    //                                 <a
    //                                     href={`http://maps.google.com/maps?q=loc:${fetchedData.latitude},${fetchedData.longitude}`}
    //                                     className="secondaryButton"
    //                                 >
    //                                     <p className="fontSize_14 fontWeight_semiBold fontColor_white">
    //                                         Direction
    //                                     </p>
    //                                 </a>
    //                             }
    //                         </div> */}
    //                     </div>
    //                 </div>
    //                 <div className="dealerDetail_dealerSection_margin">
    //                     <DealerSection
    //                         t={t} 
    //                         data={dealerList} 
    //                         brandName={fetchedData?.brand_name} 
    //                         brandCustomUrl={fetchedData?.brand_custom_url}
    //                         loading={loading} 
    //                         setPhoneNumberList={setPhoneNumberList}
    //                         setPhoneCallOpen={setPhoneCallOpen}
    //                     />
    //                 </div>
    //                 <Footer t={t} />
    //             </div>
    //             <PhoneCallListModal
    //                 phoneCallOpen={phoneCallOpen}
    //                 setPhoneCallOpen={setPhoneCallOpen} 
    //                 phoneNumberList={phoneNumberList}
    //                 t={t}
    //             />
    //         </div>
    //     </>
        
    // )
}